export default __webpack_public_path__ + "80b56cac30f6f75702c1e34e5d81fe75.svg";